import React from "react";
import Navbar from "../components/Navbar";
import FormAccessManager from "./FormAccessManager";

export default function FormAccess(props) {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-20">
        <Navbar props={props} />
      </div>

      <main className="">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
          <FormAccessManager forms={props.forms} divisions={props.divisions} />
        </div>
      </main>
    </div>
  );
}
